"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const fitjava_script_client_1 = require("@amzn/fitjava-script-client");
const base_layout_1 = require("../../common/base_layout");
const CONSTANTS = __importStar(require("../../../common/constants"));
const functions_1 = require("../../../common/functions");
const auth_provider_1 = require("../../../auth/auth_provider");
var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus[AuthenticationStatus["Redirecting"] = 0] = "Redirecting";
    AuthenticationStatus[AuthenticationStatus["Authenticated"] = 1] = "Authenticated";
    AuthenticationStatus[AuthenticationStatus["Authenticating"] = 2] = "Authenticating";
    AuthenticationStatus[AuthenticationStatus["AuthenticationFailed"] = 3] = "AuthenticationFailed";
})(AuthenticationStatus || (AuthenticationStatus = {}));
function AuthenticationStatusIndicator(props) {
    let indicatorType;
    let indicatorText;
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const localBundleLoaded = localeBundle !== undefined;
    switch (props.authenticationStatus) {
        case AuthenticationStatus.Redirecting:
            indicatorType = 'loading';
            indicatorText = localBundleLoaded
                ? localeBundle.getMessage('authentication-redirecting')
                : 'Please kindly wait for redirection and login.';
            break;
        case AuthenticationStatus.Authenticated:
            indicatorType = 'success';
            indicatorText = localBundleLoaded
                ? localeBundle.getMessage('authentication-succeed')
                : 'Authenticated. Redirecting back...';
            break;
        case AuthenticationStatus.AuthenticationFailed:
            indicatorType = 'error';
            indicatorText = localBundleLoaded
                ? localeBundle.getMessage('authentication-failed')
                : 'Authentication failed. Please close the page and retry.';
            break;
        case AuthenticationStatus.Authenticating:
        default:
            indicatorType = 'loading';
            indicatorText = localBundleLoaded
                ? localeBundle.getMessage('authentication-authenticating')
                : 'Authenticating. Please kindly wait.';
    }
    return (0, jsx_runtime_1.jsx)(awsui_components_react_1.StatusIndicator, { type: indicatorType, children: indicatorText });
}
function AuthCallback() {
    const location = (0, react_router_dom_1.useLocation)();
    // Due to the limitation of React Router, we can't get rid of the '#' in the URL path if it's a single page app (SPA)
    // FIT currently doesn't support put search parameters after '#',
    // The callback URL is like https://console.beta.edm.aft.amazon.dev/?state&code=299d8c1e-fdb9-495c-8805-51d7de57f5c9#/auth
    // The part '?state&code=299d8c1e-fdb9-495c-8805-51d7de57f5c9' is search parameter and it contains auth code from FIT
    // React Router useLocation() hook doesn't support this URL format, so we have to directly read search parameter from window.location directly
    const searchParameters = new URLSearchParams(window.location.search);
    const authCode = searchParameters.get('code');
    const auth = (0, auth_provider_1.useAuth)();
    const [authenticationStatus, setAuthenticationStatus] = (0, react_1.useState)(AuthenticationStatus.Authenticating);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((0, functions_1.isEmptyString)(authCode)) {
            const fromState = location.state;
            const redirectFromPath = ((_a = fromState === null || fromState === void 0 ? void 0 : fromState.from) === null || _a === void 0 ? void 0 : _a.pathname) || ''; // Redirect back to where user visits or home page
            const redirectFromSearch = ((_b = fromState === null || fromState === void 0 ? void 0 : fromState.from) === null || _b === void 0 ? void 0 : _b.search) || ''; // Get search params too
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_REDIRECT_BACK_PATH, redirectFromPath); // Store the path in Session Storage
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_REDIRECT_BACK_SEARCH, redirectFromSearch);
            const redirectUrl = auth.getAuthUrl();
            console.log('No auth code present in search parameter, redirect to FIT login page: ' + redirectUrl);
            setAuthenticationStatus(AuthenticationStatus.Redirecting);
            new Promise((resolve) => setTimeout(resolve, 1500)).then(() => {
                window.location.href = redirectUrl;
            });
            return;
        }
        auth.storeAuthCode(authCode);
        auth.getToken()
            .then((response) => {
            // Currently FIT doesn't return user alias directly, so split email field to get one
            const decodedEmail = (0, jwt_decode_1.default)(sessionStorage.getItem(fitjava_script_client_1.Constants.SESSION_STORAGE_ID_TOKEN_KEY)).email;
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_USERNAME, decodedEmail.split('@')[0]);
            auth.setAuthState(true);
            setAuthenticationStatus(AuthenticationStatus.Authenticated);
            console.log('User is authenticated');
            // Redirect back to where user visits
            // Read the value from Session Storage and clear after that
            // If the redirect path couldn't be found, redirect to the home page
            const redirectBackPath = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_REDIRECT_BACK_PATH) || CONSTANTS.ROUTE_HOME;
            const redirectBackSearch = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_REDIRECT_BACK_SEARCH) || '';
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_REDIRECT_BACK_PATH, '');
            sessionStorage.setItem(CONSTANTS.SESSION_STORAGE_REDIRECT_BACK_SEARCH, '');
            new Promise((resolve) => setTimeout(resolve, 3000)).then(() => {
                // Format a url
                // Same for the search params issue mentioned above, we have to clean the search params first then rebuild the original url
                let newURL = '';
                // For Cloud Desktop environment, port is needed
                // Only allow certain domain be used for redirecting. EDM domains, EDM devs' supernova domains and EDM dev desktop domains.
                if (`${window.location.port}` === '') {
                    if (CONSTANTS.EDM_DOMAIN.includes(`${window.location.hostname}`) ||
                        CONSTANTS.EDM_DEV_SUPERNOVA_DOMAIN.includes(`${window.location.hostname}`)) {
                        newURL = `${window.location.protocol}//${window.location.hostname}/#${redirectBackPath}${redirectBackSearch}`;
                    }
                }
                else if (CONSTANTS.EDM_DEV_DESKTOP_DOMAIN.includes(`${window.location.hostname}`) &&
                    `${window.location.port}` === CONSTANTS.EDM_DEV_DOMAIN_PORT) {
                    newURL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/#${redirectBackPath}${redirectBackSearch}`;
                }
                else {
                    throw new Error('Redirect domain is not permitted. Please continue using correct EDM urls.');
                }
                window.location.href = newURL;
            });
        })
            .catch((error) => {
            console.log(`Failed to get token from FIT or failed to redirect due to ${JSON.stringify(error)}`);
            setAuthenticationStatus(AuthenticationStatus.AuthenticationFailed);
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(base_layout_1.BaseLayout, { content: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Modal, { onDismiss: () => {
                console.log('dismiss');
            }, visible: true, closeAriaLabel: "Close modal", header: "Authenticating", children: (0, jsx_runtime_1.jsx)(AuthenticationStatusIndicator, { authenticationStatus: authenticationStatus }) }), contentType: "default", disableContentPaddings: true, toolsHide: true }));
}
exports.default = AuthCallback;
